import React from 'react'
import { dispatch } from '@rematch/core';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Header, Modal, TextArea, Grid, Checkbox, Message } from 'semantic-ui-react'
import TextEditor from '../../../../common/TextEditor';
import LoadingComponent from '../../../../common/LoadingComponent'

class DeleteSystemNotificationModal extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      // MakeAnotherActivity: true,
      DeleteSystemNotificationError: null,
      // title:'',
      // description: '',
      // expDate: '',
      formcyButtonDisabled: false
    }
    this.onSubmitSystemNotification = this.onSubmitSystemNotification.bind(this);
    // this.setMakeAnotherActivity = this.setMakeAnotherActivity.bind(this);
    // this.updateText = this.updateText.bind(this)
  }

  buttonDisabled = (e, set) => {
    this.setState({ formcyButtonDisabled: set });
  }

  async onSubmitSystemNotification() {
    //debugger;
    try {
      await dispatch.systemNotification.deleteSystemNotification(this.props.selectedNotification);
      this.setState({ DeleteSystemNotificationError: null });
      this.props.closeModal();
    }
    catch (err) {
      this.setState({ DeleteSystemNotificationError: err })
    }

  }

  render() {
    let loading = <LoadingComponent active={this.props.loading} message="Adding..." />
    let errorMsg = this.state.DeleteSystemNotificationError ?
      <span className='clr-red'>
        {this.state.DeleteSystemNotificationError.message}
      </span>
      : null

    return (
      <Modal
        open={this.props.isDeleteSystemNotificationModalOpen}
        onClose={this.props.closeModal}
        size='tiny'
        className="basicModal"
        closeOnEscape={true}
        closeOnDimmerClick={false}
        closeIcon
      >

        {loading}
        <Form noValidate
          className="formcyForm"
          ref={ref => this.form = ref}
          id="DeleteSystemNotificationForm"
          onValidSubmit={(event) => { this.onSubmitSystemNotification(event) }}
          onValid={(e) => this.buttonDisabled(e, true)}
          onInvalid={(e) => this.buttonDisabled(e, false)}
        >
          <Modal.Content style={{ padding: "20px 20px 0 20px" }}>
            <div className="ui header">Delete System Notification</div>
            <div className="confirmMessage">
              <p>Are you sure, you want to delete this System Notification?</p>
            </div>
          </Modal.Content>

          <Modal.Actions className="actionInFormcy">
            <Button
              className="button-submit float-right"
              id='createbtn'
              type="submit"
            > Delete
             </Button>
            <Button
              id='cancelBtn'
              className="button-cancel"
              onClick={this.props.closeModal}> Cancel
             </Button>
          </Modal.Actions>
        </Form>
      </Modal>
    )
  }
}

export default DeleteSystemNotificationModal